import type p5 from 'p5';
import { getP5 } from '../../core/p5-instance';
import { CONFIG } from '../../config/game-config';
import { getAbilityButtonBounds, getGameAreaCenterX, getGameAreaX, getGameAreaEndX } from '../../utils/helpers';
import { InputAction } from '../../types/game-types';

/**
 * isSpecialButtonClicked() - スペシャルボタンがクリックされたか判定（矩形）
 */
export function isSpecialButtonClicked(): boolean {
    const p = getP5();
    const { x, y, size, height } = getAbilityButtonBounds();

    // 矩形（縦カード型）でのクリック判定
    const halfWidth = size / 2;
    const halfHeight = height / 2;
    return p.mouseX >= x - halfWidth && p.mouseX <= x + halfWidth &&
           p.mouseY >= y - halfHeight && p.mouseY <= y + halfHeight;
}

/**
 * getKeyboardTriggeredActions() - キー入力イベント時に発生するアクションを取得
 */
export function getKeyboardTriggeredActions(p: p5): InputAction[] {
    const actions: InputAction[] = [];
    const keys = CONFIG.input.keys;

    // 左移動
    if (keys.left.includes(p.key) || p.keyCode === 37) {
        actions.push('moveLeft');
    }
    // 右移動
    if (keys.right.includes(p.key) || p.keyCode === 39) {
        actions.push('moveRight');
    }
    // 射撃
    if (keys.shoot.includes(p.key)) {
        actions.push('shoot');
    }
    // スペシャル
    if (keys.special.includes(p.key)) {
        actions.push('special');
    }

    return actions;
}

/**
 * getMouseTriggeredActions() - マウスクリックイベント時に発生するアクションを取得
 */
export function getMouseTriggeredActions(p: p5): InputAction[] {
    const actions: InputAction[] = [];

    // スペシャルボタン
    if (isSpecialButtonClicked()) {
        actions.push('special');
        return actions;
    }

    // ゲームエリア外のクリックは無視（HUDパネル領域）
    const gameAreaX = getGameAreaX();
    const gameAreaEndX = getGameAreaEndX();
    if (p.mouseX < gameAreaX || p.mouseX > gameAreaEndX) {
        return actions;
    }

    // 射撃（ゲームエリア内をクリックで射撃）
    actions.push('shoot');

    // マウスクリックでの移動（ゲームエリア中央を基準）
    const centerX = getGameAreaCenterX();
    if (p.mouseX < centerX) {
        actions.push('moveLeft');
    } else {
        actions.push('moveRight');
    }

    return actions;
}
